import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";
import React from "react";
import { useNavigate } from "react-router";

function DocumentDetailNavigationButton(props: any) {
  const navigate = useNavigate();

  return (
    <Tooltip
      placement="bottom"
      title={"Translation quality check"}>
      <button
        className="button action"
        disabled={props.canEdit}
        onClick={() => navigate(`${props.record.documentId}/view-document/${props.record.id}`, { state: props.record })}>
        <FontIcon
          // className="icon-action"
          iconName="TextDocument"
        />
      </button>
    </Tooltip>
  );
}

export default DocumentDetailNavigationButton;
